import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router';
import back from '../assets/images/back_arrow.png';
import { useNavigate } from "react-router-dom";
import $ from "jquery";
import Axios from 'axios';
import { message } from 'antd'
import "../css/Header.css";
import others from "../assets/images/other.png";


const OthersMedicalVitals = () => {
    const [vitalsTrackingType, setVitalsTrackingType] = useState([]);
    const [readingValue, setReadingValue] = useState("");
    const [buttonHide, setButtonHide] = useState(false);
    const today = new Date();
    const numberOfDaysToAdd = 0;
    const date1 = today.setDate(today.getDate() + numberOfDaysToAdd);
    const defaultValue = new Date(date1).toISOString().split('T')[0] // yyyy-mm-dd
    const [date, setDate] = useState(defaultValue);
    var hour = today.getHours();
    var min = today.getMinutes();
    hour = (hour < 10 ? "0" : "") + hour;
    min = (min < 10 ? "0" : "") + min;
    var displayTime = hour + ":" + min;
    const [time, setTime] = useState(displayTime);
    const [vitalsOnSelectTrackingType, setVitalsOnSelectTrackingType] = useState("");
    const [tableData, setTableData] = useState([]);
    const [trackingId, setTrackingId] = useState('');
    const [trackingType, setTrackingType] = useState('');
    let pid = localStorage.getItem("patientid");
    const [msg, setMsg] = useState(false);
    const [ohersValue, setOthersValue] = useState("");
    const [isOpenInput, setIsOpenInput] = useState(false);

    const navigate = useNavigate();
    //const location = useLocation();
    const backHandler = () => {
        global.OTPValidation = 'true';
        navigate("/");
    }

    useEffect(() => {
        const getMasterTrackingType = async () => {
            const token = localStorage.getItem('token');
            const headers = {
                Authorization: `Bearer ${token}`, // Add the token to the request headers
            };

            try {
                const response = await Axios.get(
                    `${process.env.REACT_APP_GLOBAL_BASEURL}/api/commonapi/PickList/get_master_tracking_type?MDT=PM&user_role=rp`,
                    { headers }
                );
                if (response.data.status == '1') {
                    setVitalsTrackingType(response.data.response)
                    console.log("master tracking type :", response.data)
                }
                setIsOpenInput(false);
                setMsg(false)
                //setTrackingType(tracking_type)
                // setTrackingId(id)
                // setVitalsOnSelectTrackingType(e.target.value)
                // console.log(e.target.value)
                console.log("patientId=", pid);
                // Axios.get(`${process.env.REACT_APP_GLOBAL_BASEURL}/api/patientapi/PatientHealthTracking/get_medical_tracking_data_by_trackingid?trackingid=${response.data.response.id}&patientid=${pid}`)

                //     .then((response) => {

                //         if (response.data.status == '1') {
                //             console.log(response.data)
                //             setTableData(response.data.response);
                //             setMsg(false);
                //         }
                //         else {
                //             setTableData([]);
                //             setMsg(true);
                //         }
                //     });
            } catch (error) {
                // Display error message based on the response or fallback to a default message
                if (error.response && error.response.status == '401') {
                    console.error("Unauthorized access. Logging out.");
                    message.error(error.response.data?.message || 'Unauthorized');
                    logoutHandler(); // Ensure logout happens here for unauthorized access
                } else {
                    console.error("Error:", error.message);
                    message.error('An error occurred. Please try again.');
                }

            }
        }
        getMasterTrackingType();

    }, []);

    const logoutHandler = () => {
        localStorage.removeItem("phoneNo");
        localStorage.removeItem("patientid");
        localStorage.removeItem("patientLocalImage");
        localStorage.removeItem("patientLocalData");
        localStorage.removeItem("patientUniqueId");
        localStorage.removeItem("chronic_illness_data");
        localStorage.removeItem("allergic_information_data");
        localStorage.removeItem("family_relation_data");
        localStorage.removeItem("family_disease_data");
        localStorage.removeItem("token");

        navigate("/Login");

    }

    const onOthersValUpdate = () => {
        setIsOpenInput((prevState) => !prevState);
        if (isOpenInput) {
            setVitalsOnSelectTrackingType("");
        }
    };


    const onOthersValueHandeler = (e) => {
        console.log(e.target.value);
        setOthersValue(e.target.value);
    }

    return (
        <div className="background-container">
            <header className="header">
                <img src={back} style={{ height: 20, width: 20 }} alt="back button" onClick={backHandler} />
                <h1 className="header-title">Medical Tracking</h1>
            </header>
            <div className='first-div' style={{ backgroundColor: "#FFFFFF", }}>
                <p className="label_style" style={{ textAlign: 'left' }}>Select tracking for add/edit</p>
                {vitalsTrackingType.map((val) => {
                    return (
                        <>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    padding: "15px",
                                    backgroundColor: "#FFFFFF",
                                    cursor: "pointer",
                                }}
                                onClick={() => navigate("/editVitals", { state: { orginalValue: val } })}
                            >
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <img className='latest-vital-cards-img'
                                        src={`${process.env.REACT_APP_GLOBAL_BASEURL}/patient_tracking_icon/${val.icon}`}
                                        alt={val.tracking_type}
                                        style={{
                                            width: "20px",
                                            height: "20px",
                                            marginRight: "15px",
                                        }}
                                    />
                                    <p style={{ fontSize: "12px", fontWeight: "bold", margin: 0, color: "black" }}>
                                        {val.tracking_type}
                                    </p>
                                </div>
                            </div>
                            {/* Line Separator */}
                            <div
                                style={{
                                    height: "1px",
                                    backgroundColor: "#ccc",
                                    margin: "0 15px", // Matches padding for alignment
                                }}
                            ></div>
                        </>
                    );
                })}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "15px",
                        backgroundColor: "#FFFFFF",
                        cursor: "pointer",
                    }}
                    onClick={() => onOthersValUpdate()}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img className='latest-vital-cards-img'
                            src={others}
                            alt="Heart Rate"
                            style={{
                                width: "20px",
                                height: "20px",
                                marginRight: "15px",
                            }}
                        />
                        <p style={{ fontSize: "12px", fontWeight: "bold", margin: 0, color: "black" }}>
                            Others
                        </p>
                    </div>
                </div>
                {
                    isOpenInput && (
                        <div style={{ backgroundColor: "#FFFFFF" }}>
                            <input
                                className="input_style"
                                style={{ width: '90%', marginTop: 20 }}
                                type="text"
                                name="name"
                                required
                                value={ohersValue}
                                onChange={(e) => onOthersValueHandeler(e)}
                                placeholder="add tracking name here"
                                maxLength={30}
                            />
                            <form
                                method="post"
                                onClick={() => navigate("/customEditVitals", { state: { tracking_name: ohersValue } })}
                                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} // Align form content
                            >
                                {buttonHide === false ? (
                                    <button
                                        type="submit"
                                        style={{
                                            marginTop: 20,
                                            width: 70,
                                            fontSize: 12,
                                            textAlign: "center", // Center text in the button
                                        }}
                                        className="btn btn-primary"
                                        disabled={!ohersValue.trim()} // Disable if the input is empty or contains only spaces
                                    >
                                        Create
                                    </button>
                                ) : (
                                    <p
                                        style={{
                                            fontSize: 12,
                                            color: "green",
                                            fontWeight: "bold",
                                            marginTop: 15,
                                            textAlign: "center", // Center text in the paragraph
                                        }}
                                    >
                                        Creating...
                                    </p>
                                )}
                            </form>
                        </div>
                    )
                }

            </div>
        </div>
    )
}

export default OthersMedicalVitals
